module.exports = __webpack_public_path__ + "img/kart-white.31372e13.svg";